import Header from '@/components/Header';
import Footer from '@/components/Footer';
import PageHero from '@/components/PageHero';
import Section from '@/components/Section';
import FeatureRow from './components/FeatureRow';
import TechSection from './components/TechSection';
import { HERO, FEATURE, TECH } from './config';
import styles from './index.module.scss';

export default function ExplainAgent() {
  return (
    <div className={styles.page}>
      <Header />
      <main>
        <PageHero image={HERO.image} alt={HERO.title} innerClassName={styles.heroInner}>
          <h1>{HERO.title}</h1>
          <p>{HERO.subtitle}</p>
        </PageHero>

        <Section
          title={FEATURE.title}
          subTitle={FEATURE.subTitle}
          className={styles.featureSection}
        >
          <div className={styles.featureList}>
            {FEATURE.cards.map((item) => (
              <FeatureRow key={item.title} {...item} />
            ))}
          </div>
        </Section>

        <TechSection
          titleLines={TECH.titleLines}
          subTitle={TECH.subTitle}
          points={TECH.points}
          background={TECH.background}
        />
      </main>
      <Footer />
    </div>
  );
}
